import EditRoles from './EditRoles';

export default EditRoles;
